// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import getUsedBandsCounts from './getUsedBandsCounts'

const getProjectBandOptions = () => (dispatch, getState) => {
  const { domain } = getState()

  const bandsFromDomain = domain.getIn(['regulatorySettings', 'bands'])

  const usedBandIds = dispatch(getUsedBandsCounts())

  // this will be the initially selected band when the bulk edits page first loads.
  // it will be based on which ever band has the greatest number of paths
  // this defaults to ''
  let selectedBandId = null

  const bandOptions = Object.keys(usedBandIds).reduce((a, d, i) => {
    // if this band is used more times in this project than the selectedBandId is,
    // then update the selectedBandId to be this band
    // first check here is in case the usedBandIds does not have a null option.
    if (
      usedBandIds[selectedBandId] === undefined ||
      usedBandIds[selectedBandId] < usedBandIds[d]
    ) {
      selectedBandId = `${d}`
    }

    // finds the corresponding band from state
    // NOTE - sortBand is a temporary property used below purely to handle the sorting
    const bandFromState = bandsFromDomain.find(b => b.get('bandId') === +d)

    // if we found the band in redux, then add it as an option
    if (bandFromState) {
      const band = bandFromState.get('band')
      const bandId = bandFromState.get('bandId')

      a.push({
        label: `${band} GHz`,
        sortBand: band,
        value: `${bandId}`,
      })

    // otherwise, this is an unassigned band and should be an empty value
    } else {
      a.push({
        label: 'No Band',
        sortBand: null,
        value: '',
      })
    }
    return a
  }, [])
    // sort this list - the sortBand here is the band's GHz value (or null if no band is assigned)
    .sort((a, b) => a.sortBand - b.sortBand)
    // omit the sortBand for the final list of options
    .map(({ label, value }) => ({
      label,
      value,
    }))

  return {
    bandOptions,
    selectedBandId,
    usedBandIds,
  }
}

export default getProjectBandOptions
